import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, isRef as _isRef, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-514a6532"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cameras_sub_head" }
const _hoisted_2 = { class: "search_conditions" }
const _hoisted_3 = { class: "camera_list" }

import { useCameraList } from '@/js/composables/useCameraList'
import TagDialog from '@/components/organisms/TagDialog'
import CameraListComponent from '@/components/organisms/CameraList'
import ContentBox from '@/components/molecules/ContentBox'
import SearchConditions from './components/SearchConditions.vue'
import DisplayRange from './components/DisplayRange.vue'
import CameraListHeader from './components/CameraListHeader.vue'
import MultiVideos from './components/MultiVideos'
import WatchStatusNotice from './components/WatchStatusNotice.vue'
import { formatQueryToArray } from '@/js/utils/filters'
import { deepCopy } from '@/js/utils/util'
import { computed, ref, watch } from 'vue'
import { onBeforeRouteUpdate, useRoute, useRouter } from 'vue-router'
import type { LocationQueryValue } from 'vue-router'
import { useStore } from 'vuex'

type RouteQueryType = {
  filter: string[]
  tags: string[]
  func: string[]
  watch_status?: LocationQueryValue | LocationQueryValue[]
  view?: LocationQueryValue | LocationQueryValue[]
  division?: LocationQueryValue | LocationQueryValue[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'main',
  setup(__props, { expose }) {

const cameraSearchConditions = ['watch_status', 'filter', 'tags', 'func'] as const
const stringQuery = ['watch_status', 'view', 'division'] as const

const store = useStore()
const route = useRoute()
const router = useRouter()

const {
  isLoaded,
  currentPage,
  totalCameras,
  cameraStatus,
  pageSize,
  cameraList,
  checkedCameras,
  toggleTagSettingDialogFlag,
  getCameras,
  changePage,
  setTag,
} = useCameraList()

// タグ設定モード切り替え用フラグ
const isDisplayTagSetting = ref(false)
// 全件チェック用
const checkedAll = ref(false)
const noSelectCamera = ref(false)
// 障害カメラ絞り込む状態
const downCameraCondition = ref(false)

const downCameraInfoDisplayFlag = computed<boolean>(
  () => store.getters['app/downCameraInfoDisplayFlag']
)
const tags = computed<{ tag_code: string }[]>(() => store.getters['tag/tags'])

const selectedTabName = computed(() => (route.query.view as string) || 'list')

// マルチ映像の分割数
const division = computed(() => {
  // 指定がない場合は分割数は4
  return Number(route.query.division) || 4
})

/**
 * タグ設定ボタンの表示切り替え
 */
const displayTagSettingBtn = computed(() => checkedCameras.value.length > 0)

/**
 * カメラ選択用にチェックボックの表示切り替え
 */
const displayCheckBox = computed(
  () => isDisplayTagSetting.value && selectedTabName.value === 'list'
)

/**
 * 故障中のカメラの有無フラグ
 */
const downCameraNotice = computed(() => {
  const down = (cameraStatus.value as { down?: number }).down
  return (down ?? 0) > 0 && downCameraInfoDisplayFlag.value
})

//  URLから現在のqueryを呼ぶ
const routeQuery = computed<RouteQueryType>(() => {
  const query: RouteQueryType = {
    filter: formatQueryToArray(route.query.filter as string | string[]) || [],
    tags: formatQueryToArray(route.query.tags as string | string[]) || [],
    func: formatQueryToArray(route.query.func as string | string[]) || [],
  }
  // viewがある場合URLに維持する
  stringQuery.forEach((key) => {
    if (route.query[key]) {
      query[key] = route.query[key]
    }
  })

  return query
})

/**
 *  検索フィルタをクリア
 */
const clearFilter = () => {
  totalCameras.value = null
  const query = {}
  routerPush(query)
}

/**
 *  タグの選択状態の変更
 */
const toggleTagBtn = () => {
  isDisplayTagSetting.value = !isDisplayTagSetting.value
}

/**
 *  タグ設定のダイアログの表示切り替え
 */
const toggleTagSettingDialog = () => {
  toggleTagSettingDialogFlag.value = !toggleTagSettingDialogFlag.value
}

/**
 *  タグを設定する対象カメラを選択
 */
const cameraChecked = (cameras: unknown[]) => {
  checkedCameras.value = cameras
}

/**
 *  タグを設定設定する対象カメラの選択をクリア
 */
const resetCheckedCameras = () => {
  checkedCameras.value = []
  checkedAll.value = false
}

/**
 *  タグ設定が行われた後にカメラリストと、選択中のカメラの更新
 */
const updateCameras = () => {
  // タグコードを配列に入れる
  const storeTagCodes = tags.value.map((tag) => tag.tag_code)

  if (routeQuery.value.tags.some((tag) => !storeTagCodes.includes(tag))) {
    // 削除タグがある場合
    const query = deepCopy(routeQuery.value)
    query.tags = query.tags.filter((tag) => storeTagCodes.includes(tag))
    routerPush(query)
  } else {
    getCameras(route)
  }
  // カメラの選択をクリア
  resetCheckedCameras()
}

/**
 *  タブの選択
 */
const selectTab = (view: string) => {
  // URLパラメーターに適用する為
  const query = Object.assign({}, route.query, { view })
  routerPush(query, route.params.page as string | number)
}

/**
 * カメラ選択状態変更やviewをmapに変更
 */
const openMap = () => {
  noSelectCamera.value = false
  selectTab('map')
}

/**
 * カメラ選択状態変更
 */
const selectCamera = () => {
  noSelectCamera.value = true
}

/**
 * マルチカメラ分割状態変更
 */
const changeDivision = (v: number | string) => {
  const query = Object.assign({}, route.query, { division: v })
  routerPush(query, route.params.page as string | number)
}

/**
 * 障害カメラ状態の更新
 */
const updateDownQuery = (status: string) => {
  const query = deepCopy(routeQuery.value)
  query.watch_status = status
  if (status === 'down') {
    downCameraCondition.value = true
  } else {
    downCameraCondition.value = false
    delete query.watch_status
  }
  routerPush(query)
}

/**
 * 検索フィルタの更新
 */
const unsetQueryParams = (type: string, value: string) => {
  //  直接 query = this.$route.queryを使うとrouter.pushができない
  const query = deepCopy(routeQuery.value)

  if (type === 'keyword') {
    query.filter = query.filter.filter((d) => d !== value)
  } else if (type === 'tag') {
    query.tags = query.tags.filter((d) => d !== value)
  } else if (type === 'func') {
    query.func = query.func.filter((d) => d !== value)
  }
  routerPush(query)
}

/**
 * routerの更新
 */
const routerPush = (query: Record<string, unknown>, page: string | number = 1) => {
  router
    .push({
      name: 'list',
      params: { page: page },
      query: query,
    })
    .catch(() => {})
}

watch(checkedAll, (v) => {
  checkedCameras.value = v === true ? (cameraList.value as unknown[]) : []
})

watch(cameraList, () => {
  // カメラにタグ設定中の時は維持するために
  if (!toggleTagSettingDialogFlag.value) {
    resetCheckedCameras()
  }
})

watch(selectedTabName, () => {
  resetCheckedCameras()
})

/**
 * コンポーネントは再利用されて、ルートだけ変わる時に呼ばれる(主にページングが実行された場合)
 */
onBeforeRouteUpdate((to, from, next) => {
  const changeState = cameraSearchConditions.some(
    (key) => JSON.stringify(to.query[key]) !== JSON.stringify(from.query[key])
  )
  // カメラ検索に必要な情報(障害、タグ、キーワード、機能,ページ)が変わった場合だけ実行する
  // 関係ない情報が変わった場合は実行しない為
  if (changeState || (to.params && to.params.page !== from.params.page)) {
    // カメラ一覧を取得
    getCameras(to)
  }

  next()
})

getCameras(route)

expose({
  isLoaded,
  currentPage,
  totalCameras,
  cameraStatus,
  pageSize,
  cameraList,
  checkedCameras,
  toggleTagSettingDialogFlag,
  getCameras,
  changePage,
  setTag,
  isDisplayTagSetting,
  checkedAll,
  noSelectCamera,
  downCameraCondition,
  selectedTabName,
  division,
  displayTagSettingBtn,
  displayCheckBox,
  downCameraNotice,
  routeQuery,
  clearFilter,
  toggleTagBtn,
  toggleTagSettingDialog,
  cameraChecked,
  resetCheckedCameras,
  updateCameras,
  selectTab,
  openMap,
  selectCamera,
  changeDivision,
  updateDownQuery,
  unsetQueryParams,
  routerPush,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(CameraListHeader, {
      checkedAll: checkedAll.value,
      "onUpdate:checkedAll": _cache[0] || (_cache[0] = ($event: any) => ((checkedAll).value = $event)),
      displayCheckBox: _unref(displayCheckBox),
      displayTagSettingBtn: _unref(displayTagSettingBtn),
      selectedTabName: _unref(selectedTabName),
      isLoaded: _unref(isLoaded),
      onToggleTagBtn: toggleTagBtn,
      onToggleTagSettingDialog: toggleTagSettingDialog,
      onSelectTab: selectTab,
      onSelectCamera: selectCamera
    }, null, 8, ["checkedAll", "displayCheckBox", "displayTagSettingBtn", "selectedTabName", "isLoaded"]),
    _createElementVNode("div", _hoisted_1, [
      (_unref(selectedTabName) !== 'multi')
        ? (_openBlock(), _createBlock(DisplayRange, {
            key: 0,
            total: _unref(totalCameras),
            currentPage: _unref(currentPage),
            isLoaded: _unref(isLoaded)
          }, null, 8, ["total", "currentPage", "isLoaded"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(SearchConditions, {
          routeQuery: _unref(routeQuery),
          onUnsetQueryParams: unsetQueryParams,
          onUpdateDownQuery: updateDownQuery
        }, null, 8, ["routeQuery"])
      ])
    ]),
    (_unref(downCameraNotice))
      ? (_openBlock(), _createBlock(WatchStatusNotice, {
          key: 0,
          "camera-status": _unref(cameraStatus),
          onUpdateDownQuery: updateDownQuery
        }, null, 8, ["camera-status"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(ContentBox), { isLoaded: _unref(isLoaded) }, {
        default: _withCtx(() => [
          (_unref(selectedTabName) !== 'multi')
            ? (_openBlock(), _createBlock(_unref(CameraListComponent), {
                key: 0,
                listType: "cameras",
                displayType: _unref(selectedTabName),
                cameraList: _unref(cameraList),
                displayCheckBox: _unref(displayCheckBox),
                useAllCheck: checkedAll.value,
                totalCameras: _unref(totalCameras),
                pageSize: _unref(pageSize),
                currentPage: _unref(currentPage),
                noSelectCamera: noSelectCamera.value,
                checkedCameras: _unref(checkedCameras),
                downCameraCondition: downCameraCondition.value,
                onCameraChecked: cameraChecked,
                onSetTag: _unref(setTag),
                onOpenMap: openMap,
                onChangePage: _unref(changePage),
                onClearFilter: clearFilter
              }, null, 8, ["displayType", "cameraList", "displayCheckBox", "useAllCheck", "totalCameras", "pageSize", "currentPage", "noSelectCamera", "checkedCameras", "downCameraCondition", "onSetTag", "onChangePage"]))
            : _createCommentVNode("", true),
          (_unref(selectedTabName) === 'multi')
            ? (_openBlock(), _createBlock(_unref(MultiVideos), {
                key: 1,
                division: _unref(division),
                onChangeDivision: changeDivision,
                onClearFilter: clearFilter
              }, null, 8, ["division"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["isLoaded"])
    ]),
    _createVNode(_unref(TagDialog), {
      toggleState: _unref(toggleTagSettingDialogFlag),
      "onUpdate:toggleState": _cache[1] || (_cache[1] = ($event: any) => (_isRef(toggleTagSettingDialogFlag) ? (toggleTagSettingDialogFlag).value = $event : null)),
      checkedCameras: _unref(checkedCameras),
      displayCheckBox: _unref(displayCheckBox),
      onUpdateCameraList: updateCameras
    }, null, 8, ["toggleState", "checkedCameras", "displayCheckBox"])
  ]))
}
}

})